/* Verified Spiker Carpet & Tile Care proof numbers — the SINGLE SOURCE for the
 * only review counts that may appear anywhere on the site (Trust Addendum
 * §3.4 / Gate A). No other review count may be shown. Cross-platform verified
 * total = Google (Galt) + Google (Lodi) + Yelp + Facebook. */

export const SPIKER_REVIEWS = {
  googleGalt: 359,
  googleLodi: 108,
  yelp: 134,
  facebook: 457,
} as const;

/** Verified cross-platform review total = 1,058. */
export const SPIKER_VERIFIED_REVIEWS =
  SPIKER_REVIEWS.googleGalt + SPIKER_REVIEWS.googleLodi + SPIKER_REVIEWS.yelp + SPIKER_REVIEWS.facebook;

export const SPIKER_YEARS = 13;

/** The real-business trust anchor (Trust Addendum §3.4), rendered verbatim. */
export const SPIKER_ANCHOR = `Built by the team behind Spiker Carpet & Tile Care — a real ${SPIKER_YEARS}-year Sacramento Valley business with ${SPIKER_VERIFIED_REVIEWS.toLocaleString()} verified reviews. We build what we run.`;
